export class Multiselect {
    constructor(element) {
        this.el = element;
        this._refs = {
            selectedCategory : element.querySelector('[data-id="MultiselectCategory"]'),
            categoriesOptions : element.querySelectorAll('[data-id="MultiselectOption"]'),
            leftSquareLabel : element.querySelector('.configurator__multiselect-checkboxes .configurator__multiselect-description'),
            rightSquareLabel : element.querySelector('.configurator__multiselect-chosenoptions .configurator__multiselect-description'),
            rightSquare : element.querySelector('.configurator__multiselect-chosenoptions')
        }
        this._refs.selectedCategory.addEventListener('change', this._multiselectDropDownChange.bind(this));
        this._refs.categoriesOptions.forEach(x=>x.addEventListener('change', this._categoriesOptionsCheckboxChange.bind(this)));
        this._init();
    }

    async _init() {
        this._setInitialChosenReasons();
    }

    //add the checked checkbox items in the chosen reasons right square
    _setInitialChosenReasons(){
        if (this.el.querySelector('.configurator__multiselect-chosenoptions .configurator__multiselect-chosenoptions_option') == null && this.el.querySelectorAll('[data-id="MultiselectOption"] input[type="checkbox"]:checked').length > 0){
            this._refs.rightSquareLabel.classList.add('is-hidden');
            //add all the checked reseons in the chosen options right square 
            this.el.querySelectorAll('[data-id="MultiselectOption"] input[type="checkbox"]:checked').forEach(checkedOption => {
                this._refs.rightSquare.insertAdjacentHTML("beforeend", this._chosenOptionTemplate(checkedOption.labels[0].innerText, checkedOption.id));
                this.el.querySelector('[data-checkbox-id="' + checkedOption.id +'"] i').addEventListener('click', this._removeOption.bind(this));
            })
            //update number of chosen options
            this.el.querySelector('.chosenOptionsCount').innerText =  this.el.querySelectorAll('.configurator__multiselect-chosenoptions .configurator__multiselect-chosenoptions_option').length;
        }
    }


    //on drop down change show appropriate category options and if default label is selected show the default messages in the squares
    _multiselectDropDownChange(){
        const chosenDDValue = (this._refs.selectedCategory).options[(this._refs.selectedCategory).selectedIndex].dataset.valuecode;
        let numberOfOptionsInCategory = 0;
        this._refs.categoriesOptions.forEach(function (el){
            if (el.dataset.parentCategory === chosenDDValue){
                el.classList.remove('is-hidden');
                el.classList.add('d-block');
                numberOfOptionsInCategory++;
            }
            else {
                el.classList.remove('d-block');
                el.classList.add('is-hidden');
            }
        })
        //if default drop down option is selected show default msg in left square
        if (chosenDDValue === undefined) {
            this._refs.leftSquareLabel.classList.remove('is-hidden');
             //update number of options under that category
             this.el.querySelector('.shownOptionsCount').innerText = '(' + 0 + ')';
        }
        else {
            this._refs.leftSquareLabel.classList.add('is-hidden');
             //update number of options under that category
            this.el.querySelector('.shownOptionsCount').innerText = '(' + numberOfOptionsInCategory + ')';
        }

       
    }

    //on category option checkbox change place/remove the element in the chosen options and if there are no options selected show the default messages in the right square and update the 
    _categoriesOptionsCheckboxChange(e){
        if (e.srcElement.checked){
            this._refs.rightSquare.insertAdjacentHTML("beforeend", this._chosenOptionTemplate(e.srcElement.labels[0].innerText, e.srcElement.id));
            this.el.querySelector('[data-checkbox-id="' + e.srcElement.id +'"] i').addEventListener('click', this._removeOption.bind(this));
        }
        else {
            const elToRemove = this.el.querySelector('[data-checkbox-id="' + e.srcElement.id +'"]');
            elToRemove?.remove();
        }
        //if there is at least one element checked hide msq or show it if none is checked
        const chosenOptions = this.el.querySelectorAll('.configurator__multiselect-chosenoptions .configurator__multiselect-chosenoptions_option');
        if (chosenOptions.length > 0){
            this._refs.rightSquareLabel.classList.add('is-hidden');
            //update number of chosen options
            this.el.querySelector('.chosenOptionsCount').innerText = chosenOptions.length;
        }
        else {
            this._refs.rightSquareLabel.classList.remove('is-hidden');
            this.el.querySelector('.chosenOptionsCount').innerText = '(' + 0 + ')';
        }
    }

    //click on trash icon - remove from right square, uncheck option and update number of chosen options
    _removeOption(e){
        //remove from right square
        e.srcElement.parentElement.remove();
        //uncheck checkbox
        const checkboxId = e.srcElement.parentElement.dataset.checkboxId;
        let theCheckbox = document.getElementById(checkboxId);
        theCheckbox.checked = false; // This doesn't fire the change event!!!
        // So we fire it
        this._triggerEvent(theCheckbox, 'input');
        this._triggerEvent(theCheckbox, 'change');
        //update number of chosen options
        this.el.querySelector('.chosenOptionsCount').innerText = parseFloat(this.el.querySelector('.chosenOptionsCount').innerText) - 1;
    }

    //template for chosen option
    _chosenOptionTemplate(title, checkboxId){
        return `
        <div class="configurator__multiselect-chosenoptions_option" data-checkbox-id="${checkboxId}">${title} <i class="eva eva-trash-2-outline"></i></div>
         `;
     }

     _triggerEvent(element, eventName) {
        let changeEvent = new Event(eventName);
        element.dispatchEvent(changeEvent);
     }

}